import { useEffect, useState } from 'react';

const useMatchMedia = condition => {
  const [matchCondition, setMatchCondition] = useState(false);
  useEffect(() => {
    // set initial value
    const mediaWatcher = window.matchMedia(condition);
    setMatchCondition(mediaWatcher.matches);

    // watch for updates
    function updateIsNarrowScreen(e) {
      setMatchCondition(e.matches);
    }
    mediaWatcher.addEventListener('change', updateIsNarrowScreen);

    // clean up after ourselves
    return function cleanup() {
      mediaWatcher.removeEventListener('change', updateIsNarrowScreen);
    };
  }, []);
  return matchCondition;
};

export default useMatchMedia;
